module.exports = __webpack_public_path__ + "img/pr-14.24e78722.png";